//All the available sensors
const sensorTypes = [
    {
        name: "iDOL 53",
        type: "DOL53"
    },
    {
        name: "iDOL 90",
        type: "DOL90"
    },
    {
        name: "iDOL 139",
        type: "IDOL139"
    }
]

export default sensorTypes;